import { Auth0Provider } from '@auth0/auth0-react';
import type React from 'react';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const currentOrganization = localStorage.getItem('organization_id');
  return (
    <Auth0Provider
      domain={import.meta.env.PUBLIC_AUTH0_DOMAIN}
      clientId={import.meta.env.PUBLIC_AUTH0_CLIENT_ID}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      cacheLocation="localstorage"
      onRedirectCallback={(appState: any) => {
        const target = appState?.returnTo || window.location.pathname;
        window.history.replaceState({}, document.title, target);
      }}
      authorizationParams={{
        audience: import.meta.env.PUBLIC_AUTH0_AUDIENCE,
        redirect_uri: import.meta.env.PUBLIC_AUTH0_LOGIN_REDIRECT_URI,
        scope: 'openid profile email offline_access',
        ...(currentOrganization && { organization: currentOrganization }),
      }}
    >
      {children}
    </Auth0Provider>
  );
};
